import { all, takeLatest, takeEvery, take } from 'redux-saga/effects';
import { authSaga } from './authSaga';
import * as albumBuilderSaga from './albumBuilderSaga';
import { albumBuilderConstants as albumBuilderC } from '../actions/constants/albumBuilderConstants';
import { authConstants } from '../actions/constants/authConstants';
import { onboardingSaga } from './onboardingSaga';
import { commonSaga } from './commonSaga';
import { userSagaFunctions } from './userSaga';
import { onboardingConstants } from '../actions/constants/onboardingConstants';
import { commonConstants } from '../actions/constants/commonConstants';
import { userConstants } from '../actions/constants/userConstants';
import { termsAndConditionConstants } from '@/actions/constants/termsAndConditionConstants';
import { termsAndConditionSaga } from './termsAndConditionSaga';
import { cookieConstants } from '@/actions/constants/cookieConstants';
import { cookieSaga } from './cookiesSaga';
import { eventConstants } from '@/actions/constants/eventConstants';
import { attendanceConstants } from '../actions/constants/attendanceConstants';
import * as attendanceSaga from './attendanceSaga';
import { studioConstants } from '@/actions/constants/studioConstants';
import { studioSaga } from './studioSaga';
import { eventSaga } from './eventSaga';
import { availabilityConstants } from '@/actions/constants/availabilityConstants';
import { availabilitySaga } from './availabilitySaga';
import { dashboardConstants } from '@/actions/constants/dashboardConstants';
import { dashboardSaga } from './dashboardSaga';
import { mediaConstants } from '@/actions/constants/mediaConstants';
import { mediaSaga } from './mediaSaga';
import { enquiryConstants } from '@/actions/constants/enquiryConstant';
import { enquirySaga } from './enquirySaga';
import { financialConstants } from "@/actions/constants/financialConstants";
import * as financialSaga from "./financialSaga";
import { eventAlbumSelectionSaga } from "./eventAlbumSelectionSaga";
import { eventAlbumSelectionConstants as albumSelectionC } from "@/actions/constants/eventAlbumSelectionConstants";
import { eventAlbumSelectionUploadSaga } from "./eventAlbumSelectionUploadSaga";
import { eventAlbumSelectionUploadConstants as albumUploadC } from "@/actions/constants/eventAlbumSelectionUploadConstants";
import * as eventAlbumSaga from "./eventAlbumSaga";
import { eventAlbumConstants as eventAlbumC } from "@/actions/constants/eventAlbumConstants";
import { commentConstants } from '@/actions/constants/commentConstants';
import { commentSaga } from './commentsSaga';
import { planConstants } from "@/actions/constants/planConstants";
import { subscriptionConstants } from "@/actions/constants/subscriptionConstants";
import { subscriptionSaga } from "./subscriptionSaga";
import {planSaga} from './planSaga';
import { routeConstants } from "@/actions/constants/routeConstants";
import { routesSaga } from "./routesSaga";


function* rootSaga() {
    yield all([
        takeLatest(authConstants.userLoginRequest, authSaga.userLogin),
        takeLatest(authConstants.userLogoutRequest, authSaga.userLogout),
        takeLatest(authConstants.userVerifyOtpRequest, authSaga.verifyOtp),
        takeLatest(authConstants.verifyInviteRequest, authSaga.verifyInvite),
        takeLatest(authConstants.userResendInviteRequest, authSaga.userResendInvite),
        takeLatest(authConstants.sendOtpRequest, authSaga.sendOtp),
        takeLatest(authConstants.resendOtpRequest, authSaga.resendOtp),

    takeLatest(onboardingConstants.inviteUserRequest, onboardingSaga.inviteUser),
    takeLatest(onboardingConstants.signupRequest, onboardingSaga.signup),
    takeLatest(onboardingConstants.verifyKycRequest, onboardingSaga.verifyKyc),
    takeLatest(onboardingConstants.referralDecisionRequest, onboardingSaga.referralDecision),
    takeLatest(onboardingConstants.fetchReferralsRequest, onboardingSaga.fetchReferrals),
    takeLatest(onboardingConstants.fetchUserDetailsRequest, onboardingSaga.fetchUserDetails),
    takeLatest(onboardingConstants.processDecisionRequest, onboardingSaga.processDecision),
    takeLatest(onboardingConstants.fetchDraftRequest, onboardingSaga.fetchDraft),

    takeLatest(commonConstants.getServicesListRequest, commonSaga.getServiceList),
    takeLatest(commonConstants.getSpecializationsListRequest, commonSaga.getSpecializationsList),
    takeLatest(commonConstants.getDocumentTypesListRequest, commonSaga.getDocumentTypesList),
    takeEvery(commonConstants.uploadFileRequest, commonSaga.uploadFile),
    takeEvery(commonConstants.removeFileRequest, commonSaga.removeFile),
    takeLatest(commonConstants.getRoleRequest, commonSaga.getRole),
    takeLatest(commonConstants.getStudioListRequest, commonSaga.getStudioList),
    takeLatest(commonConstants.getNotificationCountRequest, commonSaga.getNotificationCount),
    takeLatest(commonConstants.listNotificationsRequest, commonSaga.listNotifications),
    takeLatest(commonConstants.markAllReadRequest, commonSaga.markAllRead),
    takeLatest(commonConstants.markOneReadRequest, commonSaga.markOneRead),
    takeLatest(commonConstants.fetchNotificationSettingsRequest, commonSaga.fetchNotificationSettings),
    takeLatest(commonConstants.updateNotificationSettingsRequest, commonSaga.updateNotificationSettings),
    takeLatest(commonConstants.getRoutesListRequest, commonSaga.getRoutes),
    takeLatest(commonConstants.getAccessibleRoutesListRequest, commonSaga.getAccessibleRoutes),
    takeLatest(commonConstants.viewNotificationRequest, commonSaga.viewNotification),
    takeLatest(commonConstants.getAlbumTemplatesRequest, commonSaga.getAlbumTemplatesList),
    takeLatest(commonConstants.contactUsRequest, commonSaga.contactUs ),
    takeLatest(commonConstants.generateSessionSasRequest, commonSaga.generateSessionSas),

    takeLatest(userConstants.listUsersRequest, userSagaFunctions.listUsers),
    takeLatest(userConstants.listMembersRequest, userSagaFunctions.listMembers),
    takeLatest(userConstants.listPhotographersRequest, userSagaFunctions.listPhotographers),
    takeLatest(userConstants.inviteUserRequest, userSagaFunctions.inviteUser),
    takeLatest(userConstants.viewUserRequest, userSagaFunctions.viewUser),
    takeLatest(userConstants.editUserRequest, userSagaFunctions.editUser),
    takeLatest(userConstants.viewKycdocumentRequest, userSagaFunctions.viewKycdocument),
    takeLatest(userConstants.deleteUserRequest, userSagaFunctions.deleteUser),
    takeLatest(userConstants.processDeleteRequest, userSagaFunctions.processDeleteRequest),
    takeLatest(userConstants.listDeleteRequestsRequest, userSagaFunctions.listDeleteRequests),
    takeLatest(userConstants.revokeUserRequest, userSagaFunctions.revokeUser),
    takeLatest(userConstants.submitUpdateRequestRequest, userSagaFunctions.submitUpdateRequest),
    takeLatest(userConstants.processUpdateRequestRequest, userSagaFunctions.processUpdateRequest),
    takeLatest(userConstants.listUpdateRequestsRequest, userSagaFunctions.listUpdateRequests),

        takeLatest(termsAndConditionConstants.termsAndConditionRequest,termsAndConditionSaga.getTermsAndCondition),
        takeLatest(termsAndConditionConstants.termsofServiceRequest,termsAndConditionSaga.getTermsOfService),
        takeLatest(termsAndConditionConstants.privacyPolicyRequest,termsAndConditionSaga.getPrivacyPolicy),

        takeLatest(cookieConstants.createCookieRequest,cookieSaga.createCookiesSaga),
        takeLatest(cookieConstants.getCookieRequest, cookieSaga.getCookiesSaga),
        takeLatest(cookieConstants.updateCookieRequest,cookieSaga.updateCookiesSaga),
        //events
        takeLatest(eventConstants.createEventRequest, eventSaga.createEvent),
        takeLatest(eventConstants.listEventsRequest, eventSaga.listEvents),
        takeLatest(attendanceConstants.markAttendanceRequest, attendanceSaga.markAttendance),
        takeLatest(attendanceConstants.getEventAttendanceRequest, attendanceSaga.getEventAttendance),
        takeLatest(eventConstants.assignMemberToEventsRequest, eventSaga.assignMemberToEventsSaga),
        takeLatest(eventConstants.viewEventsRequest,eventSaga.viewEvent),
        takeLatest(eventConstants.updateEventsRequest,eventSaga.updateEvent),
        takeLatest(eventConstants.closeEventRequest, eventSaga.closeEventSaga),
        takeLatest(eventConstants.getEventsWithEnquiriesRequest, eventSaga.getEventsWithEnquiriesSaga),
        takeLatest(eventConstants.updateEventStageRequest, eventSaga.updateEventStageSaga),
        //studio
        takeLatest(studioConstants.listStudiosRequest, studioSaga.listStudios),
        takeLatest(studioConstants.viewStudioRequest,studioSaga.viewStudio),
        takeLatest(studioConstants.updateStudioRequest,studioSaga.updateStudio),
        takeLatest(studioConstants.getStudioCityRequest, studioSaga.getStudioCity),
        takeLatest(studioConstants.deactivateStudioRequest, studioSaga.deactivateStudio),
        takeLatest(studioConstants.reactivateStudioRequest, studioSaga.reactivateStudio),
        takeLatest(availabilityConstants.fetchAvailabilityRequest, availabilitySaga.fetchAvailability),
        takeLatest(availabilityConstants.updateAvailabilityRequest, availabilitySaga.updateAvailability),

        //dashboard
        takeLatest(dashboardConstants.getDashboardRequest, dashboardSaga.getDashboard),

    // Media
    takeEvery(mediaConstants.uploadMediaRequest, mediaSaga.uploadMedia),
    takeLatest(mediaConstants.listMediaRequest, mediaSaga.listMedia),
    takeEvery(mediaConstants.updateMediaStatusRequest, mediaSaga.updateMediaStatus),

    // Enquiry
    takeLatest(enquiryConstants.createEnquiryRequest, enquirySaga.createEnquirySaga),
    takeLatest(enquiryConstants.listEnquiryRequest, enquirySaga.listEnquirySaga),
    takeLatest(enquiryConstants.deleteEnquiryRequest, enquirySaga.deleteEnquirySaga),
    takeLatest(enquiryConstants.viewEnquiryRequest, enquirySaga.viewEnquirySaga),
    takeLatest(enquiryConstants.updateEnquiryRequest, enquirySaga.updateEnquirySaga),

    // Financial
    takeLatest(financialConstants.getFinancialRequest, financialSaga.getFinancial),
    takeLatest(financialConstants.createPaymentRequest, financialSaga.createPayment),
    takeLatest(financialConstants.updatePaymentRequest, financialSaga.updatePayment),
    takeLatest(financialConstants.deletePaymentRequest, financialSaga.deletePayment),
    takeLatest(financialConstants.createFinancialAlertRequest, financialSaga.createFinancialAlert),
    takeLatest(financialConstants.updateFinancialAlertRequest, financialSaga.updateFinancialAlert),
    takeLatest(financialConstants.deleteFinancialAlertRequest, financialSaga.deleteFinancialAlert),
    takeLatest(financialConstants.createExpenseRequest, financialSaga.createExpense),
    takeLatest(financialConstants.updateExpenseRequest, financialSaga.updateExpense),
    takeLatest(financialConstants.deleteExpenseRequest, financialSaga.deleteExpense),
    takeLatest(financialConstants.createPayoutRequest, financialSaga.createPayout),
    takeLatest(financialConstants.updatePayoutRequest, financialSaga.updatePayout),
    takeLatest(financialConstants.deletePayoutRequest, financialSaga.deletePayout),
    takeLatest(financialConstants.createExpenseContactRequest, financialSaga.createExpenseContact),
    takeLatest(financialConstants.updateExpenseContactRequest, financialSaga.updateExpenseContact),
    takeLatest(financialConstants.deleteExpenseContactRequest, financialSaga.deleteExpenseContact),
   

    takeLatest(albumSelectionC.fetchWorkspaceRequest, eventAlbumSelectionSaga.fetchAlbumWorkspaceSaga),
    takeLatest(albumSelectionC.fetchSummaryRequest, eventAlbumSelectionSaga.fetchAlbumSelectionSummarySaga),
    takeLatest(albumSelectionC.changeStatusRequest, eventAlbumSelectionSaga.changeAlbumStatusSaga),
    takeLatest(albumSelectionC.listCuratedRequest, eventAlbumSelectionSaga.listCuratedMediaSaga),
    takeLatest(albumSelectionC.listCuratedMore, eventAlbumSelectionSaga.listCuratedMediaMoreSaga),
    takeLatest(albumSelectionC.customerValidateRequest, eventAlbumSelectionSaga.validateCustomerAccessSaga),
    takeLatest(albumSelectionC.customerSubmitRequest, eventAlbumSelectionSaga.customerSubmitSelectionSaga),
    takeLatest(albumSelectionC.addRemainingRequest, eventAlbumSelectionSaga.addRemainingPhotosSaga),
    takeLatest(albumSelectionC.addToSelectedRequest,eventAlbumSelectionSaga.addToSelectedSaga),
    takeLatest(albumSelectionC.addToBackgroundRequest,eventAlbumSelectionSaga.addToBackgroundSaga),
    takeLatest(albumSelectionC.listSelectedRequest,eventAlbumSelectionSaga.listSelectedSaga),

    takeEvery(albumUploadC.uploadAlbumImagesRequest, eventAlbumSelectionUploadSaga.uploadAlbumImages),
    takeLatest(albumUploadC.listAlbumCuratedMediaRequest, eventAlbumSelectionUploadSaga.listAlbumCuratedMedia),

    takeLatest(albumBuilderC.fetchTemplateRequest, albumBuilderSaga.fetchTemplate),
    takeLatest(albumBuilderC.createTemplateRequest, albumBuilderSaga.createTemplate),
    takeLatest(albumBuilderC.updateTemplateRequest, albumBuilderSaga.updateTemplate),
    takeLatest(albumBuilderC.listTemplatesRequest, albumBuilderSaga.listTemplates),
    takeEvery(albumBuilderC.fetchPageRequest, albumBuilderSaga.fetchPage),
    takeLatest(albumBuilderC.createPageRequest, albumBuilderSaga.createPage),
    takeLatest(albumBuilderC.deletePageRequest, albumBuilderSaga.deletePage),
    takeLatest(albumBuilderC.reorderPagesRequest, albumBuilderSaga.reorderPages),
    takeLatest(albumBuilderC.saveRequest, albumBuilderSaga.savePage),
    takeLatest(albumBuilderC.saveTemplateRequest, albumBuilderSaga.saveAlbum),
    takeLatest(albumBuilderC.createBackgroundSasRequest,albumBuilderSaga.createBackgroundSas),

    takeLatest(eventAlbumC.generateRequest, eventAlbumSaga.generateEventAlbumSaga),
    takeLatest(eventAlbumC.fetchRequest, eventAlbumSaga.fetchEventAlbumSaga),
    takeLatest(eventAlbumC.fetchBySelectionRequest, eventAlbumSaga.fetchEventAlbumBySelectionSaga),
    takeLatest(eventAlbumC.updatePagesRequest, eventAlbumSaga.updateAlbumPagesSaga),
    takeLatest(eventAlbumC.sendReviewRequest, eventAlbumSaga.sendAlbumReviewSaga),
    takeLatest(eventAlbumC.customerTokenViewRequest, eventAlbumSaga.customerViewAlbumByTokenSaga),
    takeLatest(eventAlbumC.customerViewRequest, eventAlbumSaga.customerViewAlbumSaga),
    takeLatest(eventAlbumC.customerApproveRequest, eventAlbumSaga.customerApproveAlbumSaga),
    //mixed template builder uses 
    takeLatest(albumBuilderC.fetchAlbumRequest,eventAlbumSaga.fetchAlbum),
    takeEvery(albumBuilderC.fetchAlbumPageRequest,eventAlbumSaga.fetchAlbumPage),
    takeLatest(albumBuilderC.fetchAlbumPagesRequest,eventAlbumSaga.fetchPages),
    // takeLatest(eventAlbumC.fetchPagesRequest, eventAlbumSaga.fetchPages),   
    takeLatest(albumBuilderC.saveAlbumRequest, eventAlbumSaga.saveAlbum),
    takeLatest(albumBuilderC.saveAlbumPageRequest, eventAlbumSaga.savePage),
    takeLatest(albumBuilderC.createAlbumPageRequest,eventAlbumSaga.createPage),
    takeLatest(albumBuilderC.deleteAlbumPageRequest,eventAlbumSaga.deletePage),
    takeLatest(albumBuilderC.createAlbumBackgroundSasRequest,eventAlbumSaga.createBackgroundSas),
    takeLatest(albumBuilderC.getAlumBackgroundRequest,eventAlbumSaga.getBackgroundSaga),
    takeLatest(albumBuilderC.preparePreviewRequest, albumBuilderSaga.preparePreview),
    //comments
    takeLatest(commentConstants.getCommentsListRequest, commentSaga.getCommentsList),
    takeLatest(commentConstants.addCommentRequest, commentSaga.addComment),
    takeLatest(commentConstants.editCommentRequest, commentSaga.editComment),


    //Plans
    takeLatest(planConstants.listPlanRequest, planSaga.listPlans),
    takeLatest(planConstants.createPlanRequest, planSaga.createPlan),
    takeLatest(planConstants.viewPlanRequest, planSaga.viewPlan),
    takeLatest(planConstants.updatePlanRequest, planSaga.updatePlan),

    takeLatest(subscriptionConstants.GET_SUBSCRIPTION_PLANS_REQUEST, subscriptionSaga.getSubscriptionPlansSaga),
    takeLatest(subscriptionConstants.GET_SUBSCRIPTION_SUMMARY_REQUEST, subscriptionSaga.getSubscriptionSummarySaga),
    takeLatest(subscriptionConstants.GET_SUBSCRIPTION_PAYMENTS_REQUEST, subscriptionSaga.getSubscriptionHistorySaga),
    takeLatest(subscriptionConstants.prepareSubscriptionCheckoutRequest, subscriptionSaga.prepareSubscriptionCheckoutSaga),
    takeLatest(subscriptionConstants.cancelSubscriptionRequest, subscriptionSaga.cancelSubscriptionSaga),
    
    //Subscriptions
    takeLatest(subscriptionConstants.viewSubscriptionRequest, subscriptionSaga.viewSubscription),
    takeLatest(subscriptionConstants.updateSubscriptionRequest, subscriptionSaga.updateSubscription),

    //Routes
    takeLatest(routeConstants.bulkInsertRoutesRequest, routesSaga.bulkInsertRoutes),
    takeLatest(routeConstants.updateRoutesRequest, routesSaga.updateRoutes),

    //kyc
    
  ]);
}

export default rootSaga;
